import React from 'react';
import { BasicCard } from './BasicCard';

export const BasicCards = (props) => {
    return (
        <div className="row pt-4 pb-5">
            {props.listings.map(listing => {
                return <BasicCard
                    {...props}
                    key={listing.hpId}
                    listing={listing}
                    isViewed={props.viewedContentIds.includes(listing.hpId)}
                />
            })}
        </div>
    )
}